<template>
  <!-- 人员复选 -->
  <a-modal
    title="人员选择"
    :width="600"
    :visible="isVisible"
    :destroyOnClose="true"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-tabs default-active-key="1" v-model="tabsNum" @change="tabsChange">
      <a-tab-pane key="1" tab="人员">
        <div class="ipt">
          <a-input ref="userNameInput" v-model="character.userName" placeholder="输入员工关键词检索" @change="iptChange">
            <a-icon slot="prefix" type="search" />
          </a-input>
        </div>
        <a-row>
          <a-col :span="12"  style="max-height: 240px; overflow: scroll;">
            <a-tree
              :treeData="treeData"
              show-icon
              :load-data="onLoadData"
              :replaceFields="replaceFields"
              @select="onSelect"
              >
              <a-icon slot="bank" type="bank" />
              <a-icon slot="apartment" type="apartment" />
            </a-tree>
          </a-col>
          <a-col :span="12"  style="max-height: 240px; overflow: scroll;padding-left: 15px">
            <!-- <div v-if="!isOnce" :style="{ borderBottom: '1px solid #E9E9E9', paddingBottom: '6px' }">
              <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">
                全选
              </a-checkbox>
            </div> -->
            <template v-if="(!isOnce && approveType!==0) || (!isOnce && !isShowPost)">
              <a-checkbox-group class="checkBox" v-model="checkedAllList">
                <a-checkbox v-for="item in checkedList" :checked="item.checked" :key="item.userId" :value="item" @change="onChange">
                  {{ item.username }}
                </a-checkbox>
              </a-checkbox-group>
            </template>
            <template v-else>
              <a-radio-group class="checkBox" v-model="radioValue" @change="radioChange">
                <a-radio v-for="(item, index) in checkedList" :key="index" :value="item" >
                  {{ item.username }}
                </a-radio>
              </a-radio-group>
            </template>
          </a-col>
        </a-row>
      </a-tab-pane>
      <a-tab-pane key="2" tab="岗位角色" v-if="isShowPost">
        <postRole ref="postRole" :postRoleList="postRoleList1" @changeRoleValue="changeRole" />
      </a-tab-pane>
      <a-tab-pane key="3" tab="职务" v-if="isShowPost">
        <positionVue ref="positionRef" :positionList="positionList" @changePosiSucc="changePosiSucc" />
      </a-tab-pane>
    </a-tabs>
    <div class="showUserName">
      <template v-if="!isOnce">
        <a-tag v-for="item in newCheckedAllList" :key="item.userId || item.roleId || item.dutyId" :color="systemColor(item.type)" style="margin-top: 6px;" closable @close="deleteUser(item)">
        {{ item.username || item.roleName || item.dutyName}}
      </a-tag>
      </template>
      <template v-else>
         <a-tag v-if="radioValue.username" :color="systemColor(item.type)" style="margin-top: 6px;" closable @close="deleteUser(radioValue)">
          {{ radioValue.username }}
        </a-tag>
        <a-tag v-if="radioValue.dutyName" :color="systemColor(item.type)" style="margin-top: 6px;" closable @close="deleteUser(radioValue)">
          {{ radioValue.dutyName }}
        </a-tag>
      </template>
    </div>
    <div class="approve" v-if="isShowPost">
      <p>选择节点审批类型</p>
      <div class="approveType">
        <a-radio-group v-model="approveType" @change="approveTypeChange">
          <a-radio :value="0">普通 (选择一个人进行审批即可通过)</a-radio>
          <a-radio :value="1">会签 (须所有审批人通过才可进入下个审核节点)</a-radio>
          <a-radio :value="2">或签 (任一审批人通过或拒绝即可)</a-radio>
        </a-radio-group>
      </div>
    </div>
  </a-modal>
</template>

<script>
import postRole from './postRole'
import positionVue from './position.vue'
export default {
  name: 'Personnel',
  components: { postRole, positionVue },
  props: {
    visible: { // 是否显示
      type: Boolean,
      default: false
    },
    chooseData: { // 当前选中的人员姓名
      type: Object,
      default: () => {}
    },
    isOnce: { // 是否单选
      type: Boolean,
      default: false
    },
    isShowPost: { // 是否显示岗位角色
      type: Boolean,
      default: false
    },
    approve: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      character: {
        userName: ''
      },
      tabsNum: '1',
      treeData: [],
      checkedList: [], // 选中的人员列表
      checkedAllList: [], // 全部选中的人员
      newCheckedAllList: [], // 新的全部选中的人员
      postRoleList1: [], // 岗位角色列表
      replaceFields: {
        children: 'children',
        key: 'deptId',
        title: 'deptName'
      },
      radioValue: {}, // 单选的值
      indeterminate: false, // 半选
      checkAll: false, // 全选
      isGain: true, // 是否获取到人员列表
      approveType: 0, // 审批类型
      positionList: [] // 职务列表
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.visible
      },
      set () {
        this.handleCancel()
      }
    }
  },
  watch: {
    chooseData: {
      handler (val) {
        if (val.userId || val.roleId || val.dutyId) {
          if (val.conditions >= 0) this.approveType = val.conditions
          if (!this.isOnce) {
            this.postRoleList1 = []
            this.newCheckedAllList = []
            this.positionList = []
            if (val.userName) {
              if (val.userName.includes(',')) {
                var arr = val.userName.split(',')
                var userId = val.userId.split(',')
                arr.map((item, index) => {
                  if (item === 'null') {
                    this.newCheckedAllList.push({ username: `已删除人员(id: ${userId[index]})`, userId: userId[index], type: 'user' })
                  } else {
                    this.newCheckedAllList.push({ username: item, userId: userId[index], type: 'user' })
                  }
                })
              } else {
                this.newCheckedAllList = [{ username: val.userName, userId: val.userId, type: 'user' }]
              }
            }
            if (val.roleId) {
              if (val.roleId.includes(',')) {
                var roleId = val.roleId.split(',')
                var roleName = val.roleName.split(',')
                roleId.map((item, index) => {
                  this.postRoleList1.push({ roleName: roleName[index], roleId: item, type: 'role' })
                  this.newCheckedAllList.push({ roleName: roleName[index], roleId: item, type: 'role' })
                })
              } else {
                this.postRoleList1.push({ roleName: val.roleName, roleId: val.roleId, type: 'role' })
                this.newCheckedAllList.push({ roleName: val.roleName, roleId: val.roleId, type: 'role' })
              }
            }
            if (val.dutyId) {
              if (val.dutyId.includes(',')) {
                var dutyId = val.dutyId.split(',')
                var dutyName = val.dutyName.split(',')
                dutyId.map((item, index) => {
                  this.positionList.push({ dutyName: dutyName[index], dutyId: item, type: 'position' })
                  this.newCheckedAllList.push({ dutyName: dutyName[index], dutyId: item, type: 'position' })
                })
              } else {
                this.positionList.push({ dutyName: val.dutyName, dutyId: val.dutyId, type: 'position' })
                this.newCheckedAllList.push({ dutyName: val.dutyName, dutyId: val.dutyId, type: 'position' })
              }
            }
          } else {
            this.radioValue = { username: val.userName, userId: val.userId }
          }
        } else {
          this.newCheckedAllList = []
          this.radioValue = {}
        }
      },
      immediate: true
    },
    approve: {
      handler (val) {
        this.approveType = val
      },
      immediate: true
    }
  },
  mounted () {
    this.fetch({deptId: -1})
  },
  methods: {
    systemColor (Type) {
      // return this.$store.state.setting.color[0]
      const typeColor = {
        'user': '#5585ac',
        'role': '#42b983',
        'position': '#b37bfd'
      }
      return typeColor[Type]
    },
    quchong (arr) {
      let newArr = []
      arr.forEach(item => {
        if (!newArr.find(value => value.userId === item.userId)) {
          newArr.push(item)
        }
        if (item.type === 'role' && !newArr.find(value => value.roleId === item.roleId)) {
          newArr.push(item)
        }
      })
      return newArr
    },
    tabsChange (e) {
      this.tabsNum = e
      if (e === '2' && this.approveType === 0) { // 当选择岗位角色并且审核方式为普通 则只能单选
        this.$nextTick(() => {
          this.$refs.postRole.isCheck = false
        })
      } else if (e === '3') {
        if (this.approveType === 0) { // 单选
          this.$nextTick(() => {
            this.$refs.positionRef.isCheck = false
          })
        } else { // 多选
          this.$nextTick(() => {
            this.$refs.positionRef.isCheck = true
          })
        }
      } else {
        this.$nextTick(() => {
          this.$refs.postRole.isCheck = true
        })
      }
    },
    fetch (params = {}, currentData, callback) {
      this.$get('/dept/list', {
        ...params
      }).then((res) => {
        if (params.deptId === -1) {
          this.treeData = res.data
          this.treeData.map(item => {
            this.$set(item, 'slots', { icon: 'bank' })
          })
        } else {
          let arr = res.data
          if (arr.length) {
            arr.map(item => {
              this.$set(item, 'slots', { icon: 'apartment' })
            })
            currentData.children = arr
          }
          callback()
        }
      })
    },
    onLoadData (treeNode) {
      return new Promise(resolve => {
        if (treeNode.dataRef.children.length) {
          resolve()
          return
        }
        this.fetch({deptId: treeNode.dataRef.deptId}, treeNode.dataRef, resolve)
      })
    },
    onSelect (checkedKeys) {
      if (this.isGain && checkedKeys[0]) {
        this.character.userName = ''
        this.getCheckList(checkedKeys[0])
      }
    },
    // 获取选中的人员
    getCheckList (deptId = null) {
      this.isGain = false
      var params = {
        deptId: deptId,
        pageSize: -1,
        distinct: 1,
        pageNum: -1,
        userName: this.character.userName
      }
      this.$get('/deptUser/list', {
        ...params
      }).then((res) => {
        if (res.status === 200) {
          this.checkedList = res.data.data.rows
          this.checkedList.forEach(t => {
            t.username = t.userName
          })
          var arr = []
          if (!this.isOnce) {
            this.checkAll = false
            this.newCheckedAllList.map(item => {
              if (item.deptId) {
                if (item.deptId === deptId) {
                  arr.push(item)
                }
              } else {
                arr.push(item)
              }
            })
            this.$nextTick(() => {
              this.checkedList.map(i => {
                arr.map(j => {
                  if (i.userId === j.userId) {
                    this.$set(i, 'checked', true)
                    this.checkedAllList.push(i)
                  } else {
                    this.$set(i, 'checked', false)
                  }
                })
                this.$set(i, 'type', 'user')
              })
            })
          } else {
            this.checkedList.map(i => {
              if (this.radioValue.username === i.username) {
                this.radioValue = i
              }
            })
          }
          if (this.approveType === 0 && this.newCheckedAllList[0]) { // 普通&有值 回显
            this.checkedList.map(i => {
              if (this.newCheckedAllList[0].username === i.username) {
                this.radioValue = i
              }
            })
          }
          this.isGain = true
        }
      })
    },
    // 搜索
    iptChange () {
      if (this.character.userName === '') {
        return
      }
      this.getCheckList()
    },
    uniqueFunc (arr, uniId) {
      const res = new Map()
      return arr.filter((item) => !res.has(item[uniId]) && res.set(item[uniId], 1))
    },
    // 全选
    onCheckAllChange (e) {
      if (e.target.checked) {
        var arr1 = this.newCheckedAllList.concat(this.checkedList)
        var arr2 = this.uniqueFunc(arr1, 'userId')
        this.$nextTick(() => {
          this.newCheckedAllList = arr2
          this.checkedAllList = this.checkedList
        })
        // this.checkedAllList = e.target.checked ? this.checkedList.map(item => item) : []
      } else {
        this.newCheckedAllList.map(item => {
          this.checkedList.map(i => {
            if (item.userId === i.userId) {
              i.checked = false
              this.checkedAllList = this.checkedAllList.filter(i => i.userId !== item.userId)
              var arr1 = this.newCheckedAllList.concat([])
              var arr2 = this.uniqueFunc(arr1, 'userId')
              this.newCheckedAllList = arr2
            }
          })
        })
      }
      this.$nextTick(() => {
        this.indeterminate = false
        this.checkAll = e.target.checked
      })
    },
    // 多选
    onChange (e) {
      if (e.target.checked) {
        this.newCheckedAllList.push(e.target.value)
        this.newCheckedAllList = this.quchong(this.newCheckedAllList.concat(this.checkedAllList))
      } else {
        this.checkedAllList = this.checkedAllList.filter(i => i.userId !== e.target.value.userId)
        this.newCheckedAllList = this.newCheckedAllList.filter(i => i.userId !== e.target.value.userId)
        this.deleteUser(e.target.value)
      }
      this.$nextTick(() => {
        this.indeterminate = !!this.checkedAllList.length && this.checkedAllList.length < this.checkedList.length
        this.checkAll = this.checkedAllList.length === this.checkedList.length
      })
    },
    // 单选
    radioChange (e) {
      this.radioValue = e.target.value
      this.handleOk()
    },
    approveTypeChange () { // 类型切换
      if (this.approveType === 0) {
        this.newCheckedAllList = []
        this.positionList = []
        this.postRoleList1 = []
      }
      if (this.tabsNum === '2') { // 当选中岗位角色时
        this.$nextTick(() => {
          this.$refs.postRole.isCheck = this.approveType !== 0
        })
      }
      if (this.tabsNum === '3') { // 当选中职务时
        this.$nextTick(() => {
          this.$refs.positionRef.isCheck = this.approveType !== 0
        })
      }
    },
    // 删除人员
    deleteUser (item) {
      if (!this.isOnce) {
        if (item.userId) {
          this.checkedAllList = this.checkedAllList.filter(i => i.userId !== item.userId)
          this.newCheckedAllList = this.newCheckedAllList.filter(i => (i.userId !== item.userId))
          this.checkedList = this.checkedList.map(i => {
            if (i.userId === item.userId) {
              i.checked = false
            }
            return i
          })
          this.indeterminate = !!this.checkedAllList.length && this.checkedAllList.length < this.checkedList.length
          this.checkAll = this.checkedAllList.length === this.checkedList.length
        }
        if (item.roleId) {
          this.newCheckedAllList.map(i => {
            if (i.roleName !== item.roleName && i.type === 'role') {
              console.log(i)
            }
          })
          this.newCheckedAllList = this.newCheckedAllList.filter(i => (i.roleName !== item.roleName || i.type === 'user'))
          this.postRoleList1 = this.postRoleList1.filter(t => t.roleId !== item.roleId)
          if (this.$refs.postRole) {
            this.$nextTick(() => {
              this.$refs.postRole.deleteRole(item)
            })
          }
        }
        if (item.dutyId) {
          this.newCheckedAllList.map(i => {
            if (i.dutyName !== item.dutyName && i.type === 'position') {
              console.log(i)
            }
          })
          this.newCheckedAllList = this.newCheckedAllList.filter(i => (i.dutyName !== item.dutyName || i.type !== 'position'))
          this.positionList = this.positionList.filter(t => t.dutyId !== item.dutyId)
          if (this.$refs.positionRef) {
            this.$nextTick(() => {
              this.$refs.positionRef.deleteRole(item)
            })
          }
        }
      } else {
        this.radioValue = {}
      }
    },
    // 岗位角色
    changeRole (tar, value) {
      // 单选还是多选
      if (tar.type === 'radio') {
        this.radioValue = tar.value
        this.handleOk()
      } else if (tar.type === 'checkbox') {
        if (tar.checked) {
          this.newCheckedAllList.push({...value, type: 'role'})
          this.postRoleList1.push({...value, type: 'role'})
        } else {
          this.newCheckedAllList = this.newCheckedAllList.filter(item => item.roleName !== value.roleName)
          this.postRoleList1 = this.postRoleList1.filter(item => item.roleName !== value.roleName)
        }
      }
    },
    // 职务选择完毕
    changePosiSucc (tar, value) {
      if (tar.type === 'radio') {
        this.radioValue = tar.value
        this.$set(this.radioValue, 'type', 'position')
        this.handleOk()
      } else if (tar.type === 'checkbox') {
        if (tar.checked) {
          value.dutyId = value.id
          value.dutyName = value.name
          this.newCheckedAllList.push({...value, type: 'position'})
          this.positionList.push({...value, type: 'position'})
        } else {
          let flagName1 = false
          let flagName2 = false
          for (const element of this.newCheckedAllList) {
            if (element.dutyName) {
              flagName1 = true
              break
            }
          }
          for (const element of this.positionList) {
            if (element.dutyName) {
              flagName2 = true
              break
            }
          }
          if (flagName1) {
            this.newCheckedAllList = this.newCheckedAllList.filter(item => item.dutyName !== value.name)
          } else {
            this.newCheckedAllList = this.newCheckedAllList.filter(item => item.name !== value.name)
          }
          if (flagName2) {
            this.positionList = this.positionList.filter(item => item.dutyName !== value.name)
          } else {
            this.positionList = this.positionList.filter(item => item.name !== value.name)
          }
        }
      }
    },
    // 取消
    handleCancel () {
      this.$emit('close')
      this.checkedList = []
      this.checkedAllList = []
      this.oldCheckAllList = []
      this.newCheckedAllList = []
      this.indeterminate = false
      this.checkAll = false
      this.character.userName = ''
      this.radioValue = {}
      this.approveType = 0
      this.postRoleList1 = []
      this.tabsNum = '1'
    },
    // 确定
    handleOk () {
      if (this.tabsNum === '3') {
        if (this.approveType === 0) { // 单选
          if (Object.keys(this.radioValue).length === 0) {
            this.$message.warning('请选择职务')
            return
          }
          this.$emit('success', this.radioValue, 'radioType', this.approveType)
          this.handleCancel()
        } else {
          if (!this.newCheckedAllList.length) {
            this.$message.warning('请选择职务！')
            return
          }
          if (this.isShowPost && this.newCheckedAllList.length < 2) {
            this.$message.warning('会签或签最少需要选择两人')
            return
          }
          this.$emit('success', this.newCheckedAllList, 'checkType', this.approveType)
          this.handleCancel()
        }
      } else {
        if ((!this.isOnce && this.approveType !== 0) || (!this.isOnce && !this.isShowPost)) {
          if (!this.newCheckedAllList.length) {
            this.$message.warning('请选择人员')
            return
          }
          if (this.isShowPost && this.newCheckedAllList.length < 2) {
            this.$message.warning('会签或签最少需要选择两人')
            return
          }
          this.$emit('success', this.newCheckedAllList, 'checkType', this.approveType)
          this.handleCancel()
        } else {
          if (Object.keys(this.radioValue).length === 0) {
            this.$message.warning('请选择人员')
            return
          }
          this.$emit('success', this.radioValue, 'radioType', this.approveType)
          this.handleCancel()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
  /deep/ .el-tag .el-tag__close {
    color: #fff;
  }
  /deep/ .el-tag .el-tag__close:hover {
    background-color: red;
  }
.ipt {
  width: 200px;
  position: absolute;
  right: 0;
  top: 0;
}
.checkBox {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  .ant-checkbox-wrapper:first-child {
    margin-left: 8px;
  }
  align-items: baseline;
}
.showUserName {
  margin-top: 10px;
  padding-top: 10px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
}
.approve {
  margin-top: 20px;
  border-top: 2px solid #e8e8e8;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/personnel/index.vue